import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddEditMeal from '../components/TrackerAddEditMeal';
import TrackerQuickMealForm from '../QuickMeal/TrackerQuickMealForm';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeTrackerMeal } from '../helpers/normalizers';
import { normalizeQuickMeal } from '../QuickMeal/helpers';
import { TrackerMealProps } from '../types';

const TrackerAddUserMealContainer: React.FC<TrackerMealProps> = (props) => {
  sessionStorage.setItem('tracker_depth', '1');

  // Logging a quick-meal template: the ingredient editor cannot submit a meal without products.
  if (props.trackerMealData.isQuickMeal) {
    return (
      <TrackerQuickMealForm
        key={props.trackerMealData.id}
        mealData={normalizeQuickMeal(props.trackerMealData)}
        addQuickMeal={props.addQuickMeal}
        addUserMeal={props.addUserMeal}
        saveAsUserMeal={props.saveAsUserMeal}
        date={props.date}
      />
    );
  }

  const normalizedProps = normalizeTrackerMeal(props);
  return <TrackerAddEditMeal key={normalizedProps.mealData.id} {...normalizedProps} />;
};

export default withLoading(TrackerAddUserMealContainer, UniversalPlaceholder);
